import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import { Bio } from "../../data/constants";
import useReveal from "../../utils/useReveal";
import HeroOrb from "../HeroOrb";

const HeroSection = () => {
  const [ref, vis] = useReveal();

  const splitName = Bio.name.split(" ");
  const firstName = splitName[0];
  const lastName = splitName.slice(1).join(" ");

  return (
    <Box id="about" sx={{
      minHeight: "100vh", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center", position: "relative", overflow: "hidden"
    }}>
      <HeroOrb />
      
      <Container maxWidth="md" ref={ref} className={`stagger-children ${vis ? "visible" : ""}`} sx={{ zIndex: 2, position: "relative" }}>
        
        {/* Top Secret Badge */}
        <Box sx={{
          border: "1px solid rgba(0, 240, 255, 0.4)", px: 3, py: 1, mx: "auto", mb: 8,
          width: "fit-content", bgcolor: "rgba(0, 240, 255, 0.05)",
        }}>
          <Typography sx={{
            fontFamily: "'JetBrains Mono', monospace", fontSize: "0.75rem",
            color: "#00f0ff", letterSpacing: "0.2em",
          }}>
            TOP SECRET // DOSSIER #2026
          </Typography>
        </Box>

        {/* Giant Glowing Name */}
        <Stack spacing={0} alignItems="center" sx={{ mb: 6 }}>
          <Typography variant="h1" className="sys-glow sys-glitch" sx={{
            fontSize: { xs: "4.5rem", sm: "6rem", md: "8rem" },
            lineHeight: 1, color: "#ffffff", textAlign: "center",
          }}>
            {firstName.toUpperCase()}
          </Typography>
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mt: -2 }}>
            <Typography variant="h1" className="sys-glow sys-glitch" sx={{
              fontSize: { xs: "4.5rem", sm: "6rem", md: "8rem" },
              lineHeight: 1, color: "#ffffff",
            }}>
              {lastName.toUpperCase()}
            </Typography>
            <Box className="sys-blink" sx={{
              width: { xs: 30, md: 50 }, height: { xs: 30, md: 50 },
              border: "2px solid #00f0ff", borderRadius: "50%",
              display: "flex", alignItems: "center", justifyContent: "center",
              boxShadow: "0 0 20px rgba(0,240,255,0.4)"
            }}>
              <Box sx={{ width: 4, height: 4, bgcolor: "#00f0ff", borderRadius: "50%" }} />
            </Box>
          </Stack>
        </Stack>

        {/* Roles Details */}
        <Stack spacing={1} alignItems="center">
          <Typography sx={{
            fontFamily: "'Inter', sans-serif", fontSize: { xs: "1.1rem", md: "1.4rem" },
            color: "#e6e8ec", fontWeight: 300, textAlign: "center",
          }}>
            <Box component="span" sx={{ color: "#00f0ff", fontWeight: 600 }}>Fullstack</Box> Developer .
          </Typography>
          <Typography sx={{
            fontFamily: "'Inter', sans-serif", fontSize: { xs: "1rem", md: "1.2rem" },
            color: "#858d99", fontWeight: 300, textAlign: "center",
          }}>
            <Box component="span" sx={{ color: "#00f0ff" }}>Backend</Box> that scales & <Box component="span" sx={{ color: "#00f0ff" }}>Frontend</Box> that feels smooth.
          </Typography>
          <Typography sx={{
            fontFamily: "'JetBrains Mono', monospace", fontSize: "0.8rem",
            color: "rgba(107, 117, 130, 0.8)", mt: 2, letterSpacing: "0.1em",
          }}>
            Seeking graduation opportunities.
          </Typography>
        </Stack>
      </Container>

      {/* Scroll down indicator */}
      <Box sx={{ position: "absolute", bottom: 40, left: "50%", transform: "translateX(-50%)", zIndex: 10 }}>
        <Typography component="div" sx={{
          fontFamily: "'JetBrains Mono', monospace", fontSize: "0.6rem",
          color: "rgba(107, 117, 130, 0.6)", letterSpacing: "0.2em",
          display: "flex", flexDirection: "column", alignItems: "center", gap: 1
        }}>
          SCROLL DOWN
          <Box sx={{ width: 1, height: 20, bgcolor: "rgba(0,240,255,0.3)", animation: "scanline 2s infinite" }} />
        </Typography>
      </Box>
    </Box>
  );
};

export default HeroSection;
